///borrowed from here: https://stackoverflow.com/questions/40664523/angular2-ngbdatepicker-how-to-format-date-in-inputfield
import { Injectable } from "@angular/core";
import { NgbDateParserFormatter, NgbDateStruct, NgbDateAdapter, NgbTimeAdapter, NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
import * as moment from 'moment';

function padNumber(value: number) {
	if (isNumber(value)) {
		return `0${value}`.slice(-2);
	} else {
		return "";
	}
}

function isNumber(value: any): boolean {
	return !isNaN(toInteger(value));
}

function toInteger(value: any): number {
	return parseInt(`${value}`, 10);
}


@Injectable()
export class NgbTimeNativeAdapter extends NgbTimeAdapter<Date> {
	fromModel(date: Date): NgbTimeStruct {
		return date ? {
			hour: date.getUTCHours(),
			minute: date.getUTCMinutes(),
			second: date.getUTCSeconds()
		} : null;
	}

	toModel(date: NgbTimeStruct): Date {
		var today: Date = new Date();
		return date ? new Date(today.getFullYear(), today.getMonth() - 1, today.getDay(), date.hour, date.minute, date.second) : null;
	}
}

@Injectable()
export class NgbTimeStringAdapter extends NgbTimeAdapter<string> {

	fromModel(value: string): NgbTimeStruct {
		if (!value) {
			return null;
		}
		const split = value.split(':');
		return {
			hour: parseInt(split[0], 10),
			minute: parseInt(split[1], 10),
			second: parseInt(split[2], 10)
		};
	}

	toModel(time: NgbTimeStruct): string {
		if (!time) {
			return null;
		}
		return `${this.pad(time.hour)}:${this.pad(time.minute)}:${this.pad(time.second)}`;
	}

	private pad(i: number): string {
		return i < 10 ? `0${i}` : `${i}`;
	}
}